import { isEmpty, length, prop } from 'ramda';

import { compact } from '../../../helpers/compact';
import { Document, DocumentType } from '../../../types/document';
import { toLink, toLinkFromProp, Link } from '../fields/link';
import slicesFromProp from '../fields/slices';
import { toText, toTextFromProp } from '../fields/text';
import { toBooleanFromProp } from '../fields/boolean';
import { documentEntity } from './internal';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processHeader = (data: any): HeaderType =>
  compact({
    uid: DocumentType.HEADER,
    type: DocumentType.HEADER,
    mainMenu: slicesFromProp(
      {
        menu: ({ primary = {}, items = [] }) =>
          compact({
            type: 'menu',
            label: toTextFromProp('label', primary),
            link: toLinkFromProp('link', primary),
            altColor: toBooleanFromProp('altColor', primary),
            submenus: length(items)
              ? items
                  .map((submenu) =>
                    compact({
                      label: toTextFromProp('submenu_title', submenu),
                      link: toLinkFromProp('submenu_link', submenu),
                    })
                  )
                  .filter((o) => !isEmpty(o))
              : undefined,
          }),
      },
      'menu',
      data
    ),
    searchMenu: {
      type: 'menu',
      label: toText(data?.search_label),
      link: toLink(data?.search_link),
    },
  });

export type HeaderType = Document & {
  mainMenu: {
    type: string;
    label: string;
    link?: Link;
    altColor: boolean;
    submenus?: {
      label: string;
      link: string;
    }[];
  }[];
  searchMenu: {
    type: string;
    label: string;
    link?: string;
  };
};

export const Header = documentEntity<HeaderType>(DocumentType.HEADER, {
  processStrategy: (doc) => processHeader(prop('data', doc)),
});
